/* eslint-disable no-unused-vars */
import { Steps, Row, Col, Spin, Button, message } from "antd";
import React, { useState, useEffect } from "react";
import CompanyAdmin from "./BranchAdmin";
import CompanyDetails from "./BranchDetails";
import NewRateCard from "../../views/LeadGenerationCP/NewRateCard";
import AggreementDetails from "../../views/LeadGenerationCP/AggreementDetails";
import DocumentDetails from "../../views/LeadGenerationCP/DocumentDetails";
import DefaultCompany from "../LeadGenerationCP/DefaultCompany";
import CPDetails from "../LeadGenerationCP/CPDetails";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import Heading from "../../components/Heading";
import "../CpOnboardingNew/style.scss";
import API from "../../api";
import urls from "../../api/urls";
import { customerOnboardingAPI } from "../../api/LeadApi";
import { useLocation } from "react-router-dom";
const { GET_KYC_DETAILS, GET_BRANCH_DETAILS, PATCH_BRANCH_DETAILS } = urls;

export const CompanyBranch = () => {
  const history = useLocation();
  const [current, setCurrent] = useState(0);
  const [getData, setGetData] = useState(null);
  const [headingTitle, setHeadingTitle] = useState(null);
  const [cpPinCode, setCpPinCode] = useState(null);

  useEffect(() => {
    const customerId = localStorage.getItem("customerIdCompany");
    if (customerId) {
      getCPDetails_(customerId);
    }
    window.scrollTo(0, 0);
    if (window.location.pathname.includes("onboarding")) {
      setHeadingTitle("CP onboarding");
    } else {
      setHeadingTitle("CP Lead Generation");
    }
  }, [current]);

  useEffect(() => {
    if (history.state !== null) {
      setCurrent(history.state);
    }
  }, []);

  const getCPDetails_ = async (id) => {
    const response = await customerOnboardingAPI.getLeadById(id);
    if (response?.status) {
      let data = response?.response?.data;
      setGetData(data);
    } else {
      message.error("Network error");
    }
  };

  const patchCompany = async (values, checkBtn) => {
    const id = localStorage.getItem("customerIdCompany");

    let response = await customerOnboardingAPI.patchLead(id, values);
    if (response?.status) {
      message.success("Company updated successfully.");
      if (checkBtn) {
        setCurrent(current + 1);
      }
    } else {
      message.error(response?.response?.data?.message);
    }
  };

  const onChange = (value) => {
    setCurrent(value);
  };

  const handleStepsChange = () => {
    setCurrent(current + 1);
  };

  const goBackStep = () => {
    window.scrollTo(0, 0);
    setCurrent(current - 1);
  };

  return (
    <div className="p-2">
      <Heading title={"Company Onboarding"} navigateTo={"/profile"} id={"3"} />
      <div className="">
        <div className="master-main-container">
          <Row>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              style={{ padding: "10px 15px 0 15px" }}
              className="global-steps-container lead-cp-onboard"
            >
              <Steps
                current={current}
                direction="horizontal"
                onChange={onChange}
                className="cp-steps"
                items={[
                  {
                    title: "Company Details",
                    description: "Provide your company details",
                  },

                  {
                    title: "Quotation",
                    description: "Provide rate card details",
                  },

                  {
                    title: "Aggrement Details",
                    description: "Provide aggrement details",
                  },
                  {
                    title: "Document Details",
                    description: "Provide document details",
                  },
                ]}
              />
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              {current === 0 ? (
                <CompanyAdmin
                  handleStepsChange={handleStepsChange}
                  patchCompany={patchCompany}
                  getData={getData}
                  setCpPinCodeData={(val) => setCpPinCode(val)}
                />
              ) : current === 1 ? (
                <NewRateCard
                  handleStepsChange={handleStepsChange}
                  getData={getData}
                  cpPinCodeData={cpPinCode}
                  goBackStep={goBackStep}
                  userType={"COMPANY"}
                />
              ) : current === 2 ? (
                <AggreementDetails
                  handleStepsChange={handleStepsChange}
                  goBackStep={goBackStep}
                  getData={getData}
                  userType={"COMPANY"}
                />
              ) : current === 3 ? (
                <DocumentDetails
                  handleStepsChange={handleStepsChange}
                  goBackStep={goBackStep}
                  getData={getData}
                  userType={"COMPANY"}
                />
              ) : (
                ""
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default CompanyBranch;
